<template>
  <b-row
    style="width: 100%;margin-bottom:2%;margin-left:0;"
    class="patient-identifier-input px-2"
  >
    <b-col
      cols="2"
      class="px-1"
    >
      <b-form-group
        v-if="type"
        class="mb-0"
        :state="!errors.has($tc('global.identifierType'))"
        :invalid-feedback="errors.first($tc('global.identifierType'))"
      >
        <!-- TODO: la clase "validation-control" ahora mismo pinta todas las cajas, solo debería pintar las que dejas sin completar -->
        <vt-combo-select
          v-testing="'identifier-select'"
          v-validate="'required'"
          :searchable="false"
          :class="{'validation-control': validationControl}"
          class="nowrap identifier-selector"
          :value="type"
          :options="patientIdentifierTypes"
          track-by="idtId"
          label="name"
          :placeholder="$tc('global.identifierType')"
          :allow-empty="false"
          :name="$tc('global.identifierType')"
          :data-vv-as="type.name"
          @input="onIdentifierTypeSelected"
        />
      </b-form-group>
    </b-col>
    <b-col class="px-1">
      <b-form-group
        class="mb-0"
        :state="!errors.has('internalPatientIdentifier.identifierValue')"
        :invalid-feedback="errors.first('internalPatientIdentifier.identifierValue')"
      >
        <vt-input
          v-testing="'identifier'"
          v-validate="identifierValueValidationExpression"
          :disabled="!type || type.code === PATIENT_AUTOGENERATED_GLOBAL_ID || disableIdentierWhenRequireCenter"
          :class="{'validation-control': validationControl}"
          class="form-control-sm form-control"
          :value="internalPatientIdentifier.identifierValue"
          name="internalPatientIdentifier.identifierValue"
          data-vv-name="internalPatientIdentifier.identifierValue"
          :data-vv-as="type.name"
          :placeholder="type && type.code === PATIENT_AUTOGENERATED_GLOBAL_ID ? $tc('global.autogenerated') : $tc('global.identifier')"
          @input="updateInternalPatientIdentifierValue"
        />
      </b-form-group>
    </b-col>
    <b-col
      v-if="requireCenterId"
      cols="5"
      class="px-1"
    >
      <b-form-group
        class="mb-0"
        :state="!errors.has('internalPatientIdentifier.center.id')"
        :invalid-feedback="errors.first('internalPatientIdentifier.center.id')"
      >
        <vt-combo-select
          id="centerId"
          v-testing="'center-select'"
          v-validate="'required'"
          :value="internalPatientIdentifier.center"
          :class="{'validation-control': validationControl}"
          data-vv-name="internalPatientIdentifier.center"
          :data-vv-as="$t('global.center')"
          :options="centers"
          track-by="id"
          label="name"
          :placeholder="$t('global.selectACenter')"
          @input="onChangeCenter"
        />
      </b-form-group>
    </b-col>
    <b-col
      cols="2"
      class="px-1"
    >
      <slot />
    </b-col>
  </b-row>
</template>

<script>
import { IDENTIFIER_SCOPES } from '@/api/resources/identifierScopesResource'
import { PATIENT_AUTOGENERATED_GLOBAL_ID } from '@/api/resources/PatientIdentifierResource'
import { cloneDeep } from 'lodash'

export default {
    name: 'PatientIdentifierInput',
    props: {
        validationControl: Boolean,
        editionControl: Boolean,
        editingIdentifier: Boolean,
        patientIdentifier: Object,
        patientIdentifierTypes: { type: Array },
        centers: { type: Array }
    },
    data() {
        return {
            PATIENT_AUTOGENERATED_GLOBAL_ID: PATIENT_AUTOGENERATED_GLOBAL_ID,
            selectedIdentifierRegex: new RegExp(''),
            internalPatientIdentifier: {
                center: {},
                identifierType: {},
                identifierValue: ''
            }
        }
    },
    computed: {
        identifierValueValidationExpression() {
            return {
                required: this.type?.code !== PATIENT_AUTOGENERATED_GLOBAL_ID,
                regex: this.selectedIdentifierRegex
            }
        },
        identifierTypeId() {
            return this.type && this.type.idtId
        },
        regex() {
            return this.$store.getters.regex
        },
        requireCenterId() {
            return this.type && this.type.idtScope === IDENTIFIER_SCOPES.CENTER_PATIENT
        },
        type() {
            return this.internalPatientIdentifier?.identifierType
        },
        originalIdentifierType() {
            return this.patientIdentifier && this.patientIdentifier.identifierType
        },
        disableIdentierWhenRequireCenter() {
            return !this.internalPatientIdentifier?.center?.id && !!this.requireCenterId
        }
    },
    watch: {
        originalIdentifierType() {
            this.internalPatientIdentifier = cloneDeep(this.patientIdentifier)
            if (!this.internalPatientIdentifier.identifierValue) {
                this.internalPatientIdentifier.identifierValue = ''
            }
            if (!this.internalPatientIdentifier.center) {
                this.internalPatientIdentifier.center = {}
            }
        },
        identifierTypeId(id) {
            this.setRegex(id)
        }
    },
    methods: {
        updateInternalPatientIdentifierValue(value) {
            this.internalPatientIdentifier.identifierValue = value && value.toUpperCase()
        },
        async validate() {
            return this.$validator.validate()
        },
        setRegex(identifierTypeId) {
            if (!identifierTypeId) {
                return
            }
            let identifierRegex
            if (this.requireCenterId) {
                if (this.internalPatientIdentifier.center) {
                    identifierRegex = this.regex.find((reg) => reg.identifierType.idtId === identifierTypeId && reg.center.id === this.internalPatientIdentifier.center.id)
                }
            } else {
                identifierRegex = this.regex.find((reg) => reg.identifierType.idtId === identifierTypeId)
            }
            if (identifierRegex) {
                this.selectedIdentifierRegex = new RegExp('^(?:' + identifierRegex.regex + ')$')
            } else {
                this.selectedIdentifierRegex = new RegExp('')
            }
        },
        async onIdentifierTypeSelected(identifierType) {
            const identifierTypeId = identifierType.idtId
            this.internalPatientIdentifier.identifierType = this.findIdentifierType(identifierTypeId)
            this.internalPatientIdentifier.identifierValue = null
            this.internalPatientIdentifier.center = null
            this.setRegex(identifierTypeId)
            this.$emit('identifierTypeSelected', identifierTypeId)
            await this.resetValidator()
        },
        findIdentifierType(identifierTypeId) {
            return this.patientIdentifierTypes.find(identifierType => identifierType.idtId === identifierTypeId)
        },
        getIdentifierInput() {
            return this.internalPatientIdentifier
        },
        onChangeCenter(newCenter) {
            this.internalPatientIdentifier = {
                ...this.internalPatientIdentifier,
                center: newCenter
            }
            this.setRegex(this.identifierTypeId)
        },
        async resetValidator() {
            await this.$validator.reset()
        }
    }
}

</script>

<style>
    .patient-identifier-input .identifier-selector .multiselect__content-wrapper {
        width: 250px;
    }
</style>

<style scoped>

  .more-btn button{
    padding: 0 !important;
    margin: 0 !important;
  }

  .more-btn{
    padding: 0;
    text-align:center;
  }

</style>

<style lang="scss">

.validation-control .multiselect__tags,
.validation-control.form-control{
  border-color: vt-color(red-medium);
}

</style>
